import React, { Component } from 'react'

import { Box, Grid, Button, Table, TableBody, TableCell, 
    TableContainer, TableRow, Paper } from '@material-ui/core'

import { cancel } from '../actions/main'
import { browserHistory } from 'react-router'
import './AnswersView.scss'

export default class  AnswersView extends Component{
    constructor(props){
        super(props)        
    }

    handleCancel = () => {
        cancel();
        browserHistory.push("/settings")
    }

    render(){
        const {answers} = this.props
        let elements = []
        if(answers.answerModel && answers.answerModel.decryptedElements && answers.answerModel.decryptedElements.length > 0){
            elements = answers.answerModel.decryptedElements
        }
        return (
            <Box className="AV-root">
                <Box m="5px 0 5px 30px">
                    <Box className="preview">Data</Box>
                </Box>                
                <Box m="20px 0 5px 30px" className="preview-box">
                    <Paper className="table-root">
                        <TableContainer className="table-container">
                            <Table className="table" stickyHeader aria-label="Content of selected answer">                                
                                <TableBody>
                                    {elements.map((item) => (
                                        <TableRow key={item.id} tabIndex={-1}>                                                            
                                            <TableCell >{item.label}:</TableCell>
                                            <TableCell >
                                                {
                                                    ((item) => {
                                                        switch(item.name){
                                                            case "checklist":
                                                                return (
                                                                    <div>
                                                                        {
                                                                            item.value.map((sub) => {
                                                                                return(
                                                                                    <text key={sub.id}>{sub.value}  </text>
                                                                                ) 
                                                                            })
                                                                        }
                                                                    </div>
                                                               )
                                                            case "date":
                                                                let date = new Date(item.value)
                                                                return(
                                                                    <text>{date.toDateString()}</text>
                                                                )
                                                            case "time":
                                                                let time = new Date(item.value)
                                                                return(
                                                                    <text>{time.toLocaleTimeString()}</text>
                                                                )
                                                            default:
                                                                return (
                                                                    <text>{item.value}</text>
                                                                )
                                                        }
                                                    })(item)                                                   
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>                          
                    </Paper>
                </Box>

            </Box>
        )
    }
}